import React from 'react';
import { cn } from '../../design-system/cn';
import { Modal } from './Modal';
import Button from './Button';
import ReceiptSummary from './ReceiptSummary';
import { EscrowTrustBlock } from '../../constants/trustCopy';
import { zIndex, consoleTypography, consoleRadii } from '../../design-system/tokens';

/**
 * Standard receipt-style confirmation dialog for Lockbox flows.
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  accent = 'brand',
  icon,
  iconWrapClassName = 'w-16 h-16 text-3xl',
  iconClassName = 'bg-[#8cff4a]/10 border-2 border-[#8cff4a]/30',
  title,
  message,
  summary,
  footerNote,
  confirmLabel = 'Yes',
  confirmVariant = 'primary',
  cancelLabel = 'Cancel',
  showEscrowTrust = false,
  confirming = false,
  confirmingLabel = 'Processing…',
  children,
  z = zIndex.modalConfirm,
}) {
  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : onClose}
      accent={accent}
      size="sm"
      z={z}
      bodyClassName="p-6 md:p-8 text-center relative"
      panelClassName="overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-1 bg-[#8cff4a]/80" aria-hidden />

      {icon && (
        <div
          className={cn(
            'block-confirm-icon mx-auto mb-4 flex items-center justify-center',
            consoleRadii.md,
            iconWrapClassName,
            iconClassName,
          )}
        >
          {icon}
        </div>
      )}
      <h3 className={cn(consoleTypography.section, 'mb-2')}>{title}</h3>
      {message && <p className={cn(consoleTypography.meta, 'mb-4 text-sm')}>{message}</p>}
      <ReceiptSummary rows={summary} />
      {children}
      {showEscrowTrust && <EscrowTrustBlock className="mb-6" />}
      {footerNote && (
        <p className="text-xs text-[#687386] font-medium mb-6 leading-relaxed">{footerNote}</p>
      )}
      <div className="flex flex-col gap-3">
        <Button
          type="button"
          variant={confirmVariant}
          fullWidth
          loading={confirming}
          loadingLabel={confirmingLabel}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
        <Button
          type="button"
          variant="secondary"
          fullWidth
          disabled={confirming}
          onClick={onClose}
        >
          {cancelLabel}
        </Button>
      </div>
    </Modal>
  );
}
